export default __webpack_public_path__ + "static/media/logo192x192.d8e5c389.png";